import { render, staticRenderFns } from "./template.vue?vue&type=template&id=0b346d07&scoped=true&"
import script from "./template.vue?vue&type=script&lang=ts&"
export * from "./template.vue?vue&type=script&lang=ts&"
import style0 from "./template.vue?vue&type=style&index=0&id=0b346d07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b346d07",
  null
  
)

export default component.exports